import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetCasualActiveTabs, setCasualFormUpdateActions } from "../../../Redux/Slice";

const CasualFamilyDetails = ({ propsID }) => {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();

    const initialRow = {
        name: "",
        dob: "",
        occupation: "",
        relation: "",
    };

    const [familyList, setFamilyList] = useState([
        { name: "", dob: "", occupation: "", relation: "" },
    ]);

    const relationOptions = [
        "Mother",
        "Father",
        "Spouse",
        "Son",
        "Daughter",
        "Brother",
        "Sister",
        "Guardian",
        "Other",
    ];

    useEffect(() => {
        if (state.CasualApproveRequestDatas?.Inquriy) {
            const responseData = state.CasualApproveRequestDatas.Inquriy;
            const familyData =
                responseData?.family_details ||
                responseData?.family ||
                responseData?.family_members;

            if (Array.isArray(familyData) && familyData.length > 0) {
                // Clone objects to prevent mutating read-only Redux state objects
                setFamilyList(familyData.map((item) => ({ ...item })));
            }
        }
    }, [state.CasualApproveRequestDatas?.Inquriy]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        setFamilyList((prevList) =>
            prevList.map((item, i) =>
                i === index ? { ...item, [name]: value } : item
            )
        );
    };

    const handleAddMore = () => {
        setFamilyList((prevList) => [...prevList, { ...initialRow }]);
    };

    const handleRemoveRow = (index) => {
        if (familyList.length > 1) {
            setFamilyList((prevList) => prevList.filter((_, i) => i !== index));
        } else {
            setFamilyList([{ ...initialRow }]);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Family Details Data:", familyList);
        dispatch(SetCasualActiveTabs(6));
    };

    const HandleSaveNext = () => {
        const payload = {
            id: propsID,
            data: {
                family_details: familyList
            },
            Functions: () => {
                dispatch(SetCasualActiveTabs(6))
            }
        }
        dispatch(setCasualFormUpdateActions(payload))
    }
    return (
        <div className="BodyContent">
            <div className="card">
                <div className="card-body cards">
                    <div className="UserPoup">
                        <div className="BeforForms">
                            <div className="Form">
                                <div
                                    className="ModalHeader"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span>Family Details</span>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn ButtonCSS"
                                        style={{
                                            color: "#fff",
                                            background: "#234492",
                                        }}
                                        onClick={handleAddMore}
                                    >
                                        + Add More
                                    </button>
                                </div>

                                <div className="Modal-Body ModalForms">
                                    {familyList.map((item, index) => (
                                        <div
                                            key={index}
                                            className="row align-items-center mb-3 pb-3"
                                            style={{
                                                borderBottom:
                                                    index < familyList.length - 1
                                                        ? "1px solid #eee"
                                                        : "none",
                                            }}
                                        >
                                            {/* Name - Text Field */}
                                            <div className="col-sm-3 mt-3">
                                                <label className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="name"
                                                    placeholder="Enter Name"
                                                    value={item.name || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                            {/* dob - Date Field */}
                                            <div className="col-sm-2 mt-3">
                                                <label className="form-label">DOB</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="dob"
                                                    placeholder="dob"
                                                    value={
                                                        item.dob !== undefined && item.dob !== null
                                                            ? item.dob
                                                            : ""
                                                    }
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                            {/* Relation - Single Select Dropdown */}
                                            <div className="col-sm-3 mt-3">
                                                <label className="form-label">Relation</label>
                                                <select
                                                    className="form-select form-control"
                                                    name="relation"
                                                    value={item.relation || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                >
                                                    <option value="">-- Select Relation --</option>
                                                    {relationOptions.map((rel, rIdx) => (
                                                        <option key={rIdx} value={rel}>
                                                            {rel}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Occupation - Text Field */}
                                            <div className="col-sm-3 mt-3">
                                                <label className="form-label">Occupation</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="occupation"
                                                    placeholder="Enter Occupation"
                                                    value={item.occupation || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                            {/* Delete / Remove Action */}
                                            <div className="col-sm-1 mt-4 text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm mt-2"
                                                    title="Remove"
                                                    onClick={() => handleRemoveRow(index)}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        </div>
                                    ))}

                                    <div
                                        className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            padding: "15px 0 0",
                                            marginTop: "20px",
                                        }}
                                    >
                                        {state.CasualApproveRequestDatas.Inquriy?.is_pending &&

                                            <button
                                                type="button"
                                                className="btn ButtonCSS"
                                                style={{
                                                    color: "#fff",
                                                    background: "#234492",
                                                }}
                                                onClick={HandleSaveNext}
                                            >
                                                Save & Continue
                                            </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CasualFamilyDetails;